



	/** Determines how images are blended with existing pixels when drawn. */
	export enum BlendMode {
		Normal,
		Additive,
		Multiply,
		Screen
	}
